import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    this.boundHandleAjaxError = this.handleAjaxError.bind(this)
    this.element.addEventListener('ajax:error', this.boundHandleAjaxError)
  }

  disconnect() {
    if (this.boundHandleAjaxError) {
      this.element.removeEventListener('ajax:error', this.boundHandleAjaxError)
    }
  }

  handleAjaxError(event) {
    const [, , xhr] = event.detail || []
    let message = 'Could not save — please try again.'
    try {
      const body = xhr && xhr.responseText ? JSON.parse(xhr.responseText) : null
      if (body && Array.isArray(body.errors) && body.errors.length) {
        message = `Could not save: ${body.errors.join(', ')}`
      }
    } catch (_) {}

    if (window.toastr) window.toastr.error(message)
  }
}
